<app-globe
    class="globe-container"
    [ngClass]="{ fullscreen: fullscreen }"
></app-globe>
<app-filter
    class="filter-container"
    [ngClass]="{ fullscreen: fullscreen }"
></app-filter>
<app-loading
    class="loading-container"
    [ngClass]="{ fullscreen: fullscreen }"
></app-loading>
